import { createApp, ref } from "vue";
import Toast from "../components/infos/Toast.vue";

// Conteneur qui englobe tous les toasts
const toastContainer = document.createElement("aside");
toastContainer.setAttribute("id", "toast_container");
document.body.appendChild(toastContainer);

const toasts = [];

const toastApi = (app) => ({
  init() {
    app.config.globalProperties.$toast = this;
  },

  createToast(variant, options) {
    const isEntering = ref(true);
    const isExiting = ref(false);

    let closeToast;

    const toastApp = createApp(Toast, {
      name: "Toast",
      variant,
      title: options.title,
      content: options.content,
      isEntering: isEntering.value,
      isExiting: isExiting.value,
      customClass: "custom-fade",
      onClose: () => closeToast(),
    });

    const container = document.createElement("div");
    toastContainer.appendChild(container);

    const toastInstance = toastApp.mount(container);
    toasts.push(toastInstance);

    setTimeout(() => {
      isEntering.value = false;
    }, 100);

    closeToast = () => {
      if (toastContainer.contains(container)) {
        isExiting.value = true;
        setTimeout(() => {
          toastContainer?.removeChild(container);
          toastApp.unmount();
          const index = toasts.indexOf(toastInstance);
          if (index !== -1) {
            toasts.splice(index, 1);
          }
        }, 400);
      }
    };

    setTimeout(() => {
      if (toastContainer.contains(container)) {
        closeToast();
      }
    }, 5000);
  },

  info(options) {
    this.createToast("info", options);
  },

  success(options) {
    this.createToast("success", options);
  },

  error(options) {
    this.createToast("error", options);
  },

  warning(options) {
    this.createToast("warning", options);
  },
});

export default {
  install(app) {
    const methods = toastApi(app);
    methods.init(app);
    app.config.globalProperties.$toast = methods;
  },
};
